export default function decodeCoordinates(str: string) {
  let index = 0,
    lat = 0,
    lng = 0,
    shift = 0,
    result = 0,
    byte = 0,
    latitudeChange,
    longitudeChange
  const coordinates: [number, number][] = []
  const factor = Math.pow(10, 6)
  try {
    while (index < str.length) {
      byte = 0
      shift = 0
      result = 0
      do {
        byte = str.charCodeAt(index++) - 63
        result |= (byte & 0x1f) << shift
        shift += 5
      } while (byte >= 0x20)
      latitudeChange = result & 1 ? ~(result >> 1) : result >> 1
      shift = result = 0
      do {
        byte = str.charCodeAt(index++) - 63
        result |= (byte & 0x1f) << shift
        shift += 5
      } while (byte >= 0x20)
      longitudeChange = result & 1 ? ~(result >> 1) : result >> 1
      lat += latitudeChange
      lng += longitudeChange
      coordinates.push([lat / factor, lng / factor])
    }
  } catch (e) {
    /* empty */
  }
  return coordinates
}
